import { themeGet } from '@styled-system/theme-get'
import { Dropdown } from 'react-bootstrap'
import palette from 'src/designSystem/variables/palette'
import styled, { css } from 'styled-components/macro'

export const DropdownMenuStyle = css`
  padding: 4px;
  border: 1px solid ${palette.neutral['100']};
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background: ${palette.neutral.white};
`

export const DropdownMenuItemStyle = css`
  font-size: 14px;
  font-weight: 400;
  height: 24px;
  border: none;
  border-radius: 8px;
  padding: 16px 8px;
  margin-bottom: 2px;
  width: 100%;
  &[aria-expanded='true'],
  &[aria-expanded='true']:hover {
    background-color: ${palette.neutral['500']};
    color: ${palette.neutral.white};
    svg {
      path {
        fill: ${palette.neutral.white};
      }
    }
  }
  &:hover {
    background: ${themeGet('colors.bg.neutral')};
    color: ${palette.neutral['900']};
    svg {
      path {
        fill: ${palette.neutral['500']};
      }
    }
  }
`

export const DropDownMenu = styled(Dropdown.Menu)`
  ${DropdownMenuStyle}
`

export const NestedDropdownMenu = styled.div.attrs({
  className: 'dropdown-menu',
})`
  position: absolute;
  left: 100%;
  top: 0;
  display: block;
  ${DropdownMenuStyle}
`

export const FilterOptionContainer = styled.div`
  position: relative;
`

export const DropDownMenuWithNesting = styled(Dropdown.Menu)<{
  $hasNested: boolean
}>`
  ${DropdownMenuStyle}
  ${({ $hasNested }) =>
    $hasNested &&
    `overflow: visible !important;
  max-height: fit-content !important;`}
`

export const FilterDropdownIcon = styled.div`
  display: flex;
  align-items: center;
  width: 16px;
  height: 16px;
  margin-right: 4px;
  svg {
    width: 16px;
    height: 16px;
  }
`
